// LabelValueAutoComplete.jsx
import React, { useEffect, useState } from 'react';
import { AutoComplete } from 'antd';

const LabelValueAutoComplete = ({
    value,
    onChange,
    options = [],
    placeholder = '请选择或输入',
    allowClear = true,
    showSearch = true,
    filterOption = (inputValue, option) =>
        option?.label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1,
    ...restProps
}) => {
    const [displayValue, setDisplayValue] = useState('');

    // 当外部value变化时，更新显示值
    useEffect(() => {
        if (value !== undefined && value !== null && value !== '') {
            const selectedOption = options.find(opt => opt.value === value);
            setDisplayValue(selectedOption?.label || String(value));
        } else {
            setDisplayValue('');
        }
    }, [value, options]);

    // 处理选项选择
    const handleSelect = (selectedValue, option) => {
        // 设置显示值为选中的label
        setDisplayValue(option.label);
        // 触发onChange，传递value给表单
        onChange?.(selectedValue);
    };

    // 处理输入变化
    const handleChange = (inputValue) => {
        setDisplayValue(inputValue);

        // 如果输入框清空，清空表单值
        if (inputValue === '') {
            onChange?.(undefined);
            return;
        }

        // 检查输入的内容是否匹配某个选项的label
        const matchedOption = options.find(opt => opt.label === inputValue);
        if (matchedOption) {
            // 如果完全匹配选项的label，设置对应的value
            onChange?.(matchedOption.value);
        } else {
            // 如果是自定义输入内容，直接保存输入的内容（字符串）
            onChange?.(inputValue);
        }
    };

    // 处理失去焦点时的逻辑（可选）
    const handleBlur = () => {
        // 如果当前显示的内容不在选项列表中，且不为空，则保存为自定义值
        if (displayValue && displayValue !== '') {
            const matchedOption = options.find(opt => opt.label === displayValue);
            if (!matchedOption && displayValue !== String(value)) {
                onChange?.(displayValue);
            }
        }
    };

    return (
        <AutoComplete
            value={displayValue}
            onSelect={handleSelect}
            onChange={handleChange}
            onBlur={handleBlur}
            options={options}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch={showSearch}
            filterOption={filterOption}
            {...restProps}
        />
    );
};

export default LabelValueAutoComplete;